import React, { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { clearAuth, LOGIN_PATH } from "../api/auth";
import mockqLogo from "../images/mockq-logo-dark.png";

const NAV_ITEMS = [
  { to: "/admin/dashboard", label: "Dashboard", icon: "bi-speedometer2" },
  { to: "/admin/students", label: "Students", icon: "bi-people" },
  { to: "/admin/courses", label: "Courses", icon: "bi-journal-bookmark" },
  { to: "/admin/exams", label: "Exams", icon: "bi-journal-check" },
  { to: "/admin/sections", label: "Sections", icon: "bi-diagram-3" },
  { to: "/admin/questions", label: "Questions", icon: "bi-patch-question" },
  {
    to: "/admin/todays-exams",
    label: "Today's Exams",
    icon: "bi-calendar-day",
  },
  // { to: "/admin/schedules", label: "Schedules", icon: "bi-calendar-week" },
  {
    to: "/admin/registrations",
    label: "Registrations",
    icon: "bi-clipboard-check",
  },
  { to: "/admin/payments", label: "Payments", icon: "bi-credit-card" },

  // Main admin coupon management
  { to: "/admin/coupons", label: "Coupons", icon: "bi-ticket-perforated" },

  { to: "/admin/results", label: "Results", icon: "bi-graph-up" },
  {
    to: "/admin/verification",
    label: "Verification",
    icon: "bi-shield-check",
  },
  {
    to: "/admin/proctoring",
    label: "Proctoring",
    icon: "bi-camera-video",
  },
  {
    to: "/admin/institutes",
    label: "Institutes",
    icon: "bi-building",
  },
];

const BEGINNER_ITEMS = [
  {
    to: "/admin/beginner?tab=overview",
    label: "Beginner Dashboard",
    icon: "bi-grid-1x2",
  },
  {
    to: "/admin/beginner?tab=practice",
    label: "Practice Configuration",
    icon: "bi-sliders",
  },
  {
    to: "/admin/beginner?tab=exams",
    label: "Main Exam Access",
    icon: "bi-journal-check",
  },
  {
    to: "/admin/beginner?tab=subscriptions",
    label: "Subscriptions",
    icon: "bi-credit-card",
  },
];

export default function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const beginnerRouteActive =
    location.pathname.startsWith("/admin/beginner");

  const [beginnerOpen, setBeginnerOpen] = useState(beginnerRouteActive);

  const handleLogout = () => {
    clearAuth();
    navigate(LOGIN_PATH, { replace: true });
  };

  return (
    <aside className="admin-sidenav d-flex flex-column">
      <div className="admin-brand px-3 py-4">
        <Link
          to="/admin/dashboard"
          className="admin-brand-link"
          aria-label="MockQ admin dashboard"
        >
          <img src={mockqLogo} alt="MockQ" className="admin-brand-logo" />
        </Link>
        <p className="admin-brand-subtitle mb-0">Admin Panel</p>
      </div>

      <nav className="admin-nav flex-grow-1 py-2">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `admin-navitem d-flex align-items-center gap-2 ${
                isActive ? "active" : ""
              }`
            }
          >
            <i className={`bi ${item.icon}`} />
            <span>{item.label}</span>
          </NavLink>
        ))}

        <button
          type="button"
          className={`admin-navitem beginner-menu d-flex align-items-center gap-2 w-100 border-0 ${
            beginnerRouteActive ? "active" : ""
          }`}
          aria-expanded={beginnerOpen}
          aria-controls="admin-beginner-submenu"
          onClick={() => {
            setBeginnerOpen((open) => !open);

            if (!beginnerRouteActive) {
              navigate("/admin/beginner?tab=overview");
            }
          }}
        >
          <i className="bi bi-mortarboard" />
          <span className="flex-grow-1 text-start">Beginner</span>
          <i
            className={`bi ${
              beginnerOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </button>

        {beginnerOpen && (
          <div
            id="admin-beginner-submenu"
            className="admin-beginner-submenu"
          >
            {BEGINNER_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `admin-navitem admin-navitem-sub d-flex align-items-center gap-2 ${
                    isActive &&
                    location.search === item.to.split("?")[1]
                      ? "active"
                      : ""
                  }`
                }
              >
                <i className={`bi ${item.icon}`} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        )}
      </nav>

      <div className="admin-sidebar-footer px-3 py-3">
        <button
          type="button"
          className="admin-navitem admin-logout-btn d-flex align-items-center gap-2 w-100 border-0"
          onClick={handleLogout}
        >
          <i className="bi bi-box-arrow-right" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}